<template>
  <TableApp
    titulo="Naturezas"
    subTitulo="Cadastre suas naturezas para fazer suas compras e vendas"
    acaoBtn="/#/naturezas/nova"
    textoBtn="Nova Natureza"
    api-url="natureza"
    :fields="fields"
    classFilterColumn="natureza"
    ref="natureza"
    :perPage="10"
  >
    <template slot="customRow" slot-scope="props">
      <span slot="cfop" v-if="props.field == 'cfop'">
        <span class="pl-0 pt-8">
          <div class="d-flex align-items-center">
            <div
              class="symbol symbol-40 symbol-light-primary flex-shrink-0"
              style="margin-right: 10px"
            ></div>
            <div>
              <span class="text-muted font-weight-bold d-block"
                >{{ props.rowData.cfop }} -
                {{ props.rowData.descricao_cfop }}</span
              >
            </div>
          </div>
        </span>
      </span>
      <span slot="descricao" v-if="props.field == 'descricao'">
        <span style="width: 110px">
          <div class="font-weight-bold text-muted">
          {{ props.rowData.descricao }}
          </div>
        </span>
      </span>
      <span slot="actions" v-if="props.field == 'actions'">
        <div class="row-actions" style="text-align: right !important">
          <span style="overflow: visible; position: relative; width: 130px">
            <div class="dropdown dropdown-inline">
              <router-link
                class="btn btn-sm btn-info btn-hover-info btn-icon mr-2"
                v-b-tooltip="'Editar'"
                :to="{
                  name: 'naturezasEditar',
                  params: {
                    id: props.rowData.id,
                  },
                }"
              >
                <Pencil :size="16" title="Editar" />
              </router-link>
              <button
                @click="excluir(props.rowData)"
                class="btn btn-sm btn-danger btn-hover-danger btn-icon mr-2"
                v-b-tooltip="'Excluir'"
              >
                <TrashCanIcon :size="16" />
              </button>
            </div>
          </span>
        </div>
      </span>
    </template>
  </TableApp>
</template>

<script>
import { mapGetters } from "vuex";
import Pencil from "vue-material-design-icons/Pencil.vue";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import TableApp from "@/components/Table/Table2";

export default {
  name: "app-natureza",
  components: {
    Pencil,
    TrashCanIcon,
    TableApp,
  },
  data() {
    return {
      fields: [
        {
          label: "CFOP",
          field: "cfop",
          type: "text",
          slot: true,
          sortable: true,
          width: "40%",
          filterOptions: {
            enabled: true,
            placeholder: "Pesquisar código do CFOP",
          },
        },
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: false,
          width: "40%",
        },
        {
          label: "Ações",
          field: "actions",
          sortable: false,
          slot: true,
          width: "10%",
          filterOptions: {
            enabled: false,
          },
        },
      ],
    };
  },
  methods: {
    excluir(data) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a natureza " + data.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            await this.$http.post("/natureza/delete", {
              id: data.id,
            });
            this.$refs.natureza.refresh();
            this.$toast.success("Natureza excluída!");
          }
        });
    },
  },
  computed: {
    ...mapGetters(["layoutConfig", "itsblocked"]),
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {
    if (this.itsblocked) {
      this.$router.push({ name: "assinatura" });
    }
  },
};
</script>
